export function generateOptions(max, min=1) {
    const prfs = [];
    for (let i = min; i <= max; i++) {
        prfs.push({ text: i, value: i});
    }
    return prfs;
}